require('./bootstrap');

$(document).ready(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // Froala Implementation
    initializeFroalaEditor();

    // Selectize Implementation
    $('select.selectize').each(function () {
        var create = false;
        var delimiter = ',';
        var persist = false;
        var openOnFocus = true;
        var sortField = 'value';

        // TODO Change parameters to data-attributes

        if ($(this).hasClass('create')) {
            create = true;
        }

        if ($(this).data('sortfield')) {
            sortField = $(this).data('sortfield') === 'none' ? null : $(this).data('sortfield');
        }

        if ($(this).hasClass('tag')) {
            openOnFocus = false;
            create = function (input) {
                var id;
                var url = 'tag/create';
                var slug = input.toLowerCase().replace(/ /g, '-').replace(/[-]+/g, '-').replace(/[^\w-]+/g, '');
                $.ajax({
                    'type': 'get',
                    'url': url,
                    'async': false,
                    'data': {
                        name: input,
                        slug: slug
                    }
                }).done(function (response) {
                    if (response.status === 201) {
                        console.log(response);
                        id = response.id;
                    } else {
                        console.log('ajaxerror', response);
                    }
                }).fail(function (response) {
                    console.log('ajaxerror', response);
                }).always(function (response) {
                    console.log('ajaxalways', response);
                });
                return {
                    value: id,
                    text: input
                };
            }
        }

        $(this).selectize({
            delimiter: delimiter,
            persist: persist,
            create: create,
            sortField: sortField,
            openOnFocus: openOnFocus
        });
    });

    // Flatpicker Implementation
    // https://github.com/flatpickr/flatpickr

    $('input.flatpickr').each(function () {

        // TODO Add parameters via data-attributes
        var enableTime = $(this).data('enable-time');
        var noCalendar = $(this).data('no-calendar');
        var dateFormat = $(this).data('date-format');
        var altInput = $(this).data('alt-input');
        var altFormat = $(this).data('alt-format');

        flatpickr($(this)[0], {
            enableTime: enableTime,
            noCalendar: noCalendar,
            dateFormat: dateFormat,
            altInput: altInput,
            altFormat: altFormat,
        })
    });

    // Message timeout
    setTimeout(function () {
        $('.message').animate({
            height: 'toggle',
            opacity: 'toggle'
        }, 500);
    }, 3000);

    // Accordion
    if ($(".toggle .toggle-title").hasClass('active')) {
        $(".toggle .toggle-title.active").closest('.toggle').find('.toggle-inner').show();
    }
    $(".toggle .toggle-title").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass("active").closest('.toggle').find('.toggle-inner').slideUp(200);
        }
        else {
            $(this).addClass("active").closest('.toggle').find('.toggle-inner').slideDown(200);
        }
    });

    // Default Slick Slider
    $('.default-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 4000
    });

    // Convert .svg image to SVG format (add class="svg")
    $('img.svg').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }

            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
        }, 'xml');
    });
});

// Show/hide form for creating new records
if ($('#create-record-form').length) {
    if ($('#create-record-form').hasClass('errors')) {
        $('#overlay').show();
        $('#create-record-form').show();
    }
    $(document).on('click', '#create-record', function (e) {
        $('#overlay').fadeIn(function () {
            $('#create-record-form').fadeIn('fast');
        })
    });
    $(document).on('click', '#cancel-create-record', function (e) {
        $('#create-record-form').fadeOut('fast', function () {
            $('#create-record-form')[0].reset();
            $('#overlay').fadeOut('fast');
        });
    });
};

function thisURL(params) {
    var url,
        thisURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisURL, '/', 2));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisURL = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURL = thisURL.substring(0, (thisURL.indexOf('?') == -1) ? thisURL.length : thisURL.indexOf('?'));
        thisURL = thisURL.substring(0, getPosition(thisURL, '/', 2));
        url = thisURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function thisSubURL(params) {
    var url,
        thisSubURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('?') == -1) ? thisSubURL.length : thisSubURL.indexOf('?'));
        thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisSubURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
}

function initializeFroalaEditor() {
    $('.froala_editor').froalaEditor({
        // TODO Move key to .env
        key: 'ZD3C3C2C8aD6C4C3F2G3D2I2C9C3C4tFOFSAGLUd1AVKg1SN==',
        height: 500,

        // disable quick insert
        quickInsertTags: [],

        // toolbar buttons
        toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', '|', 'paragraphFormat', 'fontSize', 'color', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertFile', 'insertImage', 'insertVideo', 'embedly', 'insertTable', '|', 'insertHR', 'selectAll', 'clearFormatting', '|', 'spellChecker', 'help', 'html', '|', 'undo', 'redo'],

        // Upload file
        fileUploadParam: 'file',
        fileUploadURL: '/admin/media',
        fileUploadMethod: 'POST',
        fileMaxSize: 20 * 1024 * 1024,
        fileAllowedTypes: ['*'],

        // Upload image
        imageUploadParam: 'file',
        imageUploadURL: '/admin/media',
        imageUploadMethod: 'POST',
        imageMaxSize: 5 * 1024 * 1024,
        imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'svg+xml'],

        // Upload video
        videoUploadParam: 'file',
        videoUploadURL: '/admin/media',
        videoUploadMethod: 'POST',
        videoMaxSize: 50 * 1024 * 1024,
        videoAllowedTypes: ['avi', 'mov', 'mp4', 'm4v', 'mpeg', 'mpg', 'wmv', 'ogv'],
    }).on('froalaEditor.file.error', function (e, editor, error, response) {
        console.log(error);
    }).on('froalaEditor.image.error', function (e, editor, error, response) {
        console.log(error);
    }).on('froalaEditor.video.error', function (e, editor, error, response) {
        console.log(error);
    });
}
